export const ValConf = async (data, file, type) => {
  const errors = [];

  if (!data.account_name && type === 2) {
    errors.push({
      type: "account_name",
      message: "nama rekening tidak boleh kosong",
    });
  } else if (!/^[A-Za-z ]+$/.test(data.account_name) && type === 2) {
    errors.push({
      type: "account_name",
      message: "nama rekening hanya mengandung alphabet",
    });
  }

  if (!data.bank_asal && type === 2) {
    errors.push({
      type: "bank_asal",
      message: "bank asal tidak boleh kosong",
    });
  }

  if (!data.account_number && type === 2) {
    errors.push({
      type: "account_number",
      message: "nama rekening tidak boleh kosong",
    });
  }

  if (!data.bukti_transfer) {
    errors.push({
      type: "bukti_transfer",
      message: "silahkan upload bukti transfer",
    });
  } else {
    const allowedExtension = ["jpeg", "jpg", "png"];
    const fileExtension = file.name.split(".").pop().toLowerCase();
    let isValidFile = false;

    for (let index in allowedExtension) {
      if (fileExtension === allowedExtension[index]) {
        isValidFile = true;
        break;
      }
    }

    if (!isValidFile) {
      errors.push({
        type: "bukti_transfer",
        message: "hanya gambar dengan format .jpeg .jpg .png",
      });
    } else if (file.size > 1050000) {
      errors.push({
        type: "bukti_transfer",
        message: "gambar tidak boleh melebihi 1 Megabytes",
      });
    }
  }

  return errors;
};
